import { DialogTitle } from "@headlessui/react";

import { Controller, SubmitHandler, useForm } from "react-hook-form";
import { Trans, useTranslation } from "react-i18next";
import VerificationInput from "react-verification-input";

import Button from "@/components/buttons/Button";

import { useDeleteAccount, useGetUser, useLogout } from "@/hooks/api/user.hooks";
import useModalRouter from "@/hooks/useModalRouter";
import { onError } from "@/utils/onError";
import { onSuccess } from "@/utils/onSuccess";

export interface DeleteAccountCodeForm {
  code: string;
}

const DeleteAccountCodeModal = () => {
  const { t } = useTranslation();
  const { reset, control, handleSubmit } = useForm<DeleteAccountCodeForm>();
  const { data: user } = useGetUser();
  const { mutate: deleteAccount, isPending } = useDeleteAccount();
  const { mutate: logout } = useLogout();
  const { closeModal } = useModalRouter();

  const onSubmit: SubmitHandler<DeleteAccountCodeForm> = async (data): Promise<void> => {
    deleteAccount(data.code, {
      onSuccess: () => {
        logout();
        onSuccess(t("account.delete-success"));
      },
      onError: (error) => {
        reset();
        onError(error);
      },
    });
  };

  return (
    <div className="max-w-[32.5rem]">
      <div className="mx-auto mb-6 max-w-[27.5rem] text-center">
        <DialogTitle as={"h2"} className={"staff-modal__title"}>
          {t("auth.confirm-code")}
        </DialogTitle>

        {user.username && (
          <Trans
            i18nKey={"auth.confirm-login-message"}
            values={{ value: user.username }}
            components={{
              1: <span className={"text-orange-1"} />,
            }}
          />
        )}
      </div>
      <form onSubmit={handleSubmit(onSubmit)} className={"space-y-8"}>
        <div className={"auth-verification relative flex justify-center"}>
          <Controller
            name={"code"}
            control={control}
            rules={{ required: true, minLength: 6 }}
            render={({ field }) => (
              <VerificationInput
                placeholder={""}
                validChars={"0-9"}
                value={field.value}
                onChange={field.onChange}
                classNames={{
                  container: "verification-input-container",
                  character: "verification-input-character",
                  characterSelected: "pin-input verification-input-character-selected",
                  characterFilled: "verification-input-character-filled",
                }}
              />
            )}
          />
        </div>

        <div className="flex flex-row gap-6">
          <Button title={t("Actions.cancel")} color={"black"} onClick={closeModal}>
            {t("Actions.cancel")}
          </Button>
          <Button type={"submit"} isLoading={isPending} title={t("Actions.confirm")} className={"w-full"}>
            {t("Actions.confirm")}
          </Button>
          {/*<ResendOtpButton />*/}
        </div>
      </form>
    </div>
  );
};

export default DeleteAccountCodeModal;
